import { GraphQLClient } from "graphql-request";
import { COOKIE_KEY } from "lib/auth-constants";
// https://github.com/prisma-labs/graphql-request

// SSR実行環境（Vercel）の内部DNSリゾルバがpublicドメイン(NEXT_PUBLIC_FRONTEND_API_BASE_URL)の
// 委任変更に追随しないことがあるため、自分宛てproxyを経由せずbackendへ直接Bearer tokenで接続する。
function buildSSRGraphqlClient(context: any) {
  return new GraphQLClient(`${process.env.NEXT_PUBLIC_BACKEND_API_BASE_URL}/graphql_supplier`, {
    headers: {
      Authorization: `Bearer ${context.req.cookies[COOKIE_KEY]}`,
      // backendに渡るとすべて/graphqlになってしまうので、独自定義のheaderを用意してbackendにも渡す。
      "X-Nitoel-Referer": context.req.headers["referer"],
    },
  });
}

export default buildSSRGraphqlClient;
